import React from 'react'
import { NavLink } from 'react-router-dom'
import './styles.scss'

const bs = 'different-activity-menu'

const Menu = ({ t, isMobile }) => (
  <div className={bs}>
    <div className={`${bs}__control`}>
      <NavLink to="/different-activity/previous" className={`${bs}__link`}>
        {t('Previous')} {!isMobile && t('Activities')}
      </NavLink>
    </div>
    <div className={`${bs}__control`}>
      <NavLink to="/different-activity/upcoming" className={`${bs}__link`}>
        {t('Upcoming')} {!isMobile && t('Activities')}
      </NavLink>
    </div>
    <div className={`${bs}__control`}>
      <NavLink to="/different-activity/favorites" className={`${bs}__link`}>
        {t('Favorites')} {!isMobile && t('Activities')}
      </NavLink>
    </div>
  </div>
)

export default Menu
